import { render, staticRenderFns } from "./ModalLoginLongFailed.vue?vue&type=template&id=5bfd53dd&scoped=true&"
import script from "./ModalLoginLongFailed.vue?vue&type=script&lang=js&"
export * from "./ModalLoginLongFailed.vue?vue&type=script&lang=js&"
import style0 from "./ModalLoginLongFailed.vue?vue&type=style&index=0&id=5bfd53dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd53dd",
  null
  
)

component.options.__file = "ModalLoginLongFailed.vue"
export default component.exports